/* eslint no-console: 0 */

export default {
  info(...args) {
    console.info(...args);
  },

  debug(...args) {
    console.debug(...args);
  },

  warn(...args) {
    console.warn(...args);
  },

  error(...args) {
    console.error(...args);
  }
};
